<template>
  <v-flex xs12>
    <data-source-table
      itemController="geotag-check"
      itemIdentifyField="geotag.name"
      :headers="headers"
      :options.sync="options"
      ref="dataSourceRef"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <span>
            Last update: {{ progress['Finished at'] ? progress['Finished at'] : 'Unknown' }}
            <v-btn
              class="mx-2"
              color="primary"
              dark
              fab
              small
              :loading="progress.Status === 'Running'"
              @click="updateStatistic"
            >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-refresh
                      </v-icon>
                    </slot>
                  </template>
                  Update statistic
                </v-tooltip>
            </v-btn>
            <span v-if="progress.Status === 'Running'">
              {{ progress['Processed rows percents'] }}%
            </span>
          </span>

          <v-dialog
            v-model="datedialog.show"
            width="290px"
          >
            <v-date-picker
              v-model="datedialog.date"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="datedialog.show=false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="saveDate()"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <v-spacer/>

          <v-btn
              class="mx-2" color="blue darken-1"
              outlined small
              @click="$refs.dataSourceRef ? $refs.dataSourceRef.openDialogSelectColumns() : false"
          >
            Select columns
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:filter_customers>
        <DataList
          :item-model.sync="options.filters.customers"
          :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
          label="customers"
          clearable
          multiple
          dense
          chips
          small-chips
          deletable-chips
          with-option-none
        />
      </template>

      <template v-slot:filter_sequence>
        <GeotagList
          :geotag-model.sync="options.filters.sequence"
          label="sequence"
          multiple
          dense
          with-option-any
          with-option-none
        />
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.geotag.name }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              class="mx-1"
              small
              outlined
              :color="countColor(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-video-image
              </v-icon>
              <span class="item-count">{{ item.geotag.videodata_count }}</span>
            </v-chip>
          </template>
          slide videos
        </v-tooltip>
      </template>

      <template v-slot:item.status="{ item }">
        {{ geotagStatus(item.geotag.status) }}
      </template>

      <template v-slot:item.pois="{ item }">
        <div><span class="font-italic">enabled</span>: {{ item.geotag.pois_count }}</div>
        <span class="font-italic">updated</span>:
        <v-btn
          color="green" outlined rounded x-small
          target="_blank"
          :to="'/attractions?ids=' + item.new_videos.join(',')"
        >
          {{ countVideos(item) }}
        </v-btn>
      </template>

      <template v-slot:item.sequence="{ item }">
        <v-chip
          v-for="tag in item.geotag.sequenceGeotags"
          :key="tag.name"
          class="ma-0"
          dark
          small
        >
          {{ tag.name }}
        </v-chip>
      </template>

      <template v-slot:item.hashtags="{ item }">
        <v-chip
          v-for="tag in item.geotag.hashtags"
          :key="tag.name"
          class="ma-0"
          dark
          small
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on">
                {{ tag.name }} ({{ tag.pois_count }} +
                {{ countHashtag(item, tag.id) }})
              </div>
            </template>
            All + new
          </v-tooltip>
        </v-chip>
      </template>

      <template v-slot:item.customers="{ item }">
        <v-chip
          v-for="customer in item.geotag.customers"
          :key="customer.name"
          class="ma-0"
          dark
          small
        >
          {{ customer.name }}
        </v-chip>
      </template>

      <template v-slot:item.date="{item}">
        <div
          @click="showDateDialog(item)"
        >
          <v-icon>mdi-calendar</v-icon>
          {{ item.date }}
        </div>
      </template>
    </data-source-table>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import DataSourceTable from '../components/DataSource/DataTable.vue';
import DataList from '../components/DataLists/DataList.vue';
import GeotagList from '../components/DataLists/GeotagList.vue';

export default {
  name: 'GeotagCheck',
  components: {
    GeotagList,
    DataList,
    DataSourceTable,
  },
  data: () => ({
    items: [],
    options: { filters: {} },
    datedialog: {
      geotag: {},
      show: false,
      date: '',
    },
    progress: {},
    customers: [],
  }),

  created() {
    this.getProgress();
  },

  mounted() {
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    countColor(geotagCheck) {
      if (geotagCheck.geotag.videodata_count > 0 && this.countVideos(geotagCheck) > 0) return '#388E3C';
      return '#BDBDBD';
    },

    countVideos(geotagCheck) {
      return geotagCheck.new_videos_count ? geotagCheck.new_videos_count : 0;
    },

    geotagStatus(status) {
      switch (status) {
        case 1:
          return 'PREV';
        case 2:
          return 'LIVE';
        default:
          return 'OFF';
      }
    },

    countHashtag(geotagCheck, hashtagId) {
      if (geotagCheck.new_hashtags[hashtagId]) {
        return geotagCheck.new_hashtags[hashtagId].length;
      }
      return 0;
    },

    updateStatistic() {
      this.$confirm('Run update history statistic').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/progress/run', {
            script: 'GeotagCheck',
          }, {
            withOverlay: false,
          })
          .then(() => {
            this.getProgress();
          });

        setTimeout(() => {
          this.getProgress();
        }, 2000);
      });
    },
    getProgress() {
      this.$requestHelpers
        .post('api/admin/progress/getProgress', {
          script: 'GeotagCheck',
        }, {
          withOverlay: false,
        })
        .then((response) => {
          this.progress = response.data;

          if (this.progress.Status === 'Running') {
            setTimeout(() => {
              this.getProgress();
            }, 2000);
          }
        });
    },

    saveDate() {
      const itemClone = { ...this.datedialog.geotag };
      itemClone.date = this.datedialog.date;

      this.$refs.dataSourceRef.updateItemField('date', this.datedialog.date, this.datedialog.geotag).finally(() => {
        this.datedialog.show = false;
      });
    },
    showDateDialog(item) {
      Object.assign(
        this.datedialog,
        {
          show: true, geotag: item, date: item.date,
        },
      );
    },
  },

  watch: {
  },

  computed: {
    headers() {
      return [
        {
          text: 'geotag_id', value: 'geotag_id', width: '120px',
        },
        {
          text: 'name', value: 'name', width: '200px',
        },
        {
          text: 'country', value: 'geotag.country', width: '200px', sortable: false,
        },
        {
          text: 'state', value: 'geotag.state', width: '200px', sortable: false,
        },
        {
          text: 'status', value: 'status', width: '200px', sortable: false, filter: { type: 'select', items: ['off', 'prev', 'prev only', 'live'] },
        },
        {
          text: 'pois', value: 'pois', width: '200px', sortable: true, filter: { type: 'disable' },
        },
        {
          text: 'sequence', value: 'sequence', width: '200px', sortable: false,
        },
        {
          text: 'hashtags', value: 'hashtags', width: '200px', sortable: true, filter: { type: 'disable' },
        },
        {
          text: 'customers', value: 'customers', width: '200px', sortable: false,
        },
        {
          text: 'date', value: 'date', width: '200px',
        },
        {
          text: 'notes', value: 'notes', width: '200px', filter: { type: 'disable' }, edit: { type: 'html' },
        },
      ];
    },
  },
};
</script>
